import FallbackLoader from '../FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ZonesSearch" */'@modals/partials/cerca-casa/ZonesSearch'));
